var t={highlighted:{fontWeight:{value:"{fontWeights.bold}"}}};export{t as highlightmatch};
